export const district = [
    {
        id: 'di1',
        name: '宜川县',
        'color': '#ee0000',
        location: [110.1712535, 36.0497844]
    },
    {
        id: 'di2',
        name: '韩城市',
        'color': '#ee0000',
        location: [110.4508029, 35.4762519]
    },
    {
        id: 'di3',
        name: '合阳县',
        'color': '#ee0000',
        location: [110.14930, 35.23800]
    },
    {
        id: 'di4',
        name: '澄城县',
        'color': '#ee0000',
        location: [109.9307087, 35.1835064]
    },
    {
        id: 'di5',
        name: '白水县',
        'color': '#ee0000',
        location: [109.5876073, 35.1785126]
    },
    {
        id: 'di6',
        name: '蒲城县',
        'color': '#ee0000',
        location: [109.5900, 34.9560]
    },
    {
        id: 'di7',
        name: '大荔县',
        'color': '#ee0000',
        location: [109.9366142, 34.7983603]
    },
    {
        id: 'di8',
        name: '富平县',
        'color': '#ee0000',
        location: [109.1692405, 34.7446812]
    },
    {
        id: 'di9',
        name: '三元县',
        'color': '#ee0000',
        location: [108.9378694, 34.6142123]
    },
]

// 地图核心控制点说明：
// - 古贤枢纽点位按公开资料“工程位于黄河中游晋陕峡谷、壶口瀑布下游约十余公里”校准到黄河主河槽附近。
// - 配水工程支线、调蓄池和部分受水区公开坐标有限，保留为演示规划坐标。
export const mapControlPoints = {
    guxianDam: {
        name: '古贤水利枢纽坝址（校准）',
        source: '公开工程区位 + 在线地图河槽位置推定',
        location: [110.4518, 36.0662, 520]
    },
    hukouWaterfall: {
        name: '壶口瀑布参照点',
        source: '公开景区位置参照',
        location: [110.4439, 36.1487, 520]
    },
    longmenStation: {
        name: '龙门水文站/龙门断面',
        source: '黄河龙门断面公开区位',
        location: [110.5660, 35.6650, 450]
    }
}

export const monitoring = [
    {
        'id': '1',
        'type': 'cinema',
        'name': '视频监控',
        "categories": 'monitoring',
        'location': [110.45155, 36.06655, 520]

    },
    {
        'id': '2',
        'type': 'building',
        'name': '坝体位移',
        "categories": 'monitoring',
        'location': [110.45218, 36.06605, 500]
    }, {
        'id': '3',
        'type': 'dam',
        'name': '水库信息',
        "categories": 'monitoring',
        'location': [110.4518, 36.0662, 500]
    },
]


export const shenMuPipe = [
    {
        id: '1',
        location: [110.1110034856346, 38.7185948503967, 2300, 110.0828015023091, 38.70643780713519, 2300, 110.12759658231455, 38.65768911755641, 2300],
    },
    {
        id: '2',
        location: [110.12294740788002, 38.72125503482552, 2300, 110.14417229337583, 38.731297634794785, 2300, 110.15590887693176, 38.71968789873728, 2300],
    },
    {
        id: '3',
        location: [110.11285304226982, 38.7612286361543, 2300, 110.1096063500616, 38.779434183374164, 2300, 110.15350045841862, 38.78546567389446, 2300],
    },
    {
        id: '4',
        location: [110.1096063500616, 38.779434183374164, 2300, 110.10683418584114, 38.79561243067425, 2300, 110.17671987295968, 38.802432839347226, 2300],
    }
]


export const hyStations = [
    {
        'id': 'h1',
        'type': 'dam',
        'name': '古贤水利枢纽',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [110.4518, 36.0662, 450],
        'source': '公开工程区位 + 在线地图河槽位置推定'
    },
    {
        'id': 'h8',
        'type': 'dam',
        'name': '薛峰水库',
        "categories": 'regulating',
        'color': '#00BFFF',
        'location': [110.3073384, 35.5304201, 450]
    },
    {
        'id': 'h2',
        'type': 'dam',
        'name': '龙潭水库',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [108.8558869, 34.9074351, 450]
    }, {
        'id': 'h3',
        'type': 'dam',
        'name': '东庄水库',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [108.4983725, 34.7307591, 450]
    },{
        'id': 'h4',
        'type': 'dam',
        'name': '小道口水库',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [108.94388700000002,34.762381, 450]
    }, {
        'id': 'h5',
        'type': 'dam',
        'name': '尚书水库',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [109.24191999999994,34.920866000000004, 450]
    }, {
        'id': 'h6',
        'type': 'dam',
        'name': '五一水库',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [109.92489,35.30922600000001, 450]
    },
    {
        'id': 'h7',
        'type': 'dam',
        'name': '喜家岭调蓄水库',
        "categories": 'regulating',
        'color': '#00BFFF',
        'location': [110.24850900000001,36.06567499999999, 450]
    },
]

export const  building = [
    {
        'name': '古贤水利枢纽',
        'type': 'dam',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [110.4518, 36.0662, 550]
    },
    {
        'name': '薛峰水库',
        'type': 'dam',
        "categories": 'regulating',
        'color': '#00BFFF',
        'location': [110.3073384, 35.5304201, 550]
    },
    {
        'name': '龙潭水库',
        'type': 'dam',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [108.8558869, 34.9074351, 550]
    },
    {
        'name': '东庄水库',
        'type': 'dam',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [108.4983725, 34.7307591, 550]
    },
    {
        'name': '小道口水库',
        'type': 'dam',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [108.943887, 34.762381, 550]
    },
    {
        'name': '尚书水库',
        'type': 'dam',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [109.24192, 34.920866, 550]
    },
    {
        'name': '五一水库',
        'type': 'dam',
        "categories": 'reservoir',
        'color': '#00BFFF',
        'location': [109.92489, 35.309226, 550]
    },
    {
        'name': '喜家岭调蓄水库',
        'type': 'dam',
        "categories": 'regulating',
        'color': '#00BFFF',
        'location': [110.248509, 36.065675, 550]
    },
]

export const protection = [
    // {
    //     'name': '农田',
    //     'type': 'commercial',
    //     "categories": 'protection',
    //     'color': '#00BFFF',
    //     'location': [110.441007, 36.15763, 450]
    // },
    // {
    //     'name': '居民区',
    //     'type': 'commercial',
    //     "categories": 'protection',
    //     'color': '#00BFFF',
    //     'location': [110.440411, 36.157155, 450]
    // },
    // {
    //     'name': '工业区',
    //     'type': 'commercial',
    //     "categories": 'protection',
    //     'color': '#00BFFF',
    //     'location': [110.439917, 36.157996, 450]
    // } ,

    {
        'name': '农田',
        'type': 'commercial',
        "categories": 'protection',
        'color': '#00BFFF',
        'location': [110.344621, 35.501468, 470]
    },
    {
        'name': '居民区',
        'type': 'commercial',
        "categories": 'protection',
        'color': '#00BFFF',
        'location': [110.345807, 35.501741, 470]
    },
    {
        'name': '工业区',
        'type': 'commercial',
        "categories": 'protection',
        'color': '#00BFFF',
        'location': [110.439917, 36.157996, 450]
    }
]




export const pumping = [
    {
        'id': 'pp1',
        'name': '堡崖一级泵站',
        "categories": 'pump',
        'color': '#13af38',
        'location': [110.069443, 35.23769, 450]
    },
    {
        'id': 'pp2',
        'name': '东雷一级泵站',
        "categories": 'pump',
        'color': '#13af38',
        'location': [110.366766, 35.23701, 450]
    },
]

export const pool = [
    {
        'id': 'pp1',
        'name': '改造小坡调蓄池',
        "categories": 'pool',
        'color': '#cec40b',
        'location': [109.992296, 34.903582, 450]
    },
    {
        'id': 'pp2',
        'name': '新建太合调蓄池',
        "categories": 'pool',
        'color': '#cec40b',
        'location': [109.589552, 35.008011, 450]
    },
]

export const irrigation = [
    {
        'id': 'ir1',
        'name': '交口抽渭灌区',
        "categories": 'irrigation',
        'color': '#16d9d3',
        'location': [109.559994, 34.647402, 450]
    },
    {
        'id': 'ir2',
        'name': '东雷抽黄灌区',
        "categories": 'pool',
        'color': '#16d9d3',
        'location': [109.461227, 34.964437, 450]
    },    {
        'id': 'ir3',
        'name': '澄城新建灌区',
        "categories": 'pool',
        'color': '#16d9d3',
        'location': [109.895998, 35.500379, 450]
    },
]

export const industrialPark = [
    {
        'id': 'ip1',
        'name': '富平庄里工业受水区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [109.0671945, 34.8234833]
    },
    {
        'id': 'ip2',
        'name': '宜川县集义物流园区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [110.3765267, 35.8275887]
    },
    {
        'id': 'ip3',
        'name': '宜川县秋林核心区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [110.2606223, 36.0825659]
    },
    {
        'id': 'ip4',
        'name': '澄城县经济技术开发区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [109.93843360325295, 35.19657281555104]
    },

    {
        'id': 'ip5',
        'name': '白水县高新技术产业开发区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [109.59752055373886, 35.18328751461316]
    },
    {
        'id': 'ip7',
        'name': '大荔科技产业园区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [109.957768, 34.720543]
    }, {
        'id': 'ip8',
        'name': '韩城市经济开发区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [110.563029, 35.628356]
    }, {
        'id': 'ip9',
        'name': '宜川县交里天然气加工区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [110.053717, 36.192073]
    },
    {
        'id': 'ip10',
        'name': '韩城市高新区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [110.401141, 35.520428]
    }    ,{
        'id': 'ip11',
        'name': '韩城市龙亭新区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [110.2561314, 35.3400965]
    },
    {
        'id': 'ip12',
        'name': '蒲城高新技术产业开发区',
        "categories": 'industrial',
        'color': '#3F4ABF',
        'location': [109.57124574638586, 34.94804131821359]
    },
]

export const FetchPipe = [
    {
        id: 'fp1',
        location: [109.0671945, 34.8234833, 1000, 109.342431, 35.009237, 1000,

            109.636339, 35.10552, 1000, 109.93843360325295, 35.19657281555104, 1000,
            110.240378, 35.237184, 1000, 110.233882, 35.279703, 1000,
            110.417266, 35.652392, 1000,
            110.3884693027277, 35.83358286594112, 1000, 110.37241, 35.98392, 1000,
            110.43088, 36.04072, 1000, 110.4518, 36.0662, 1000
        ]
    },
    {
        id: 'fp2',
        location: [110.233882, 35.279703, 1000, 110.24575, 35.216892, 1000,
            110.291703, 35.209325, 1000, 110.349693, 35.265671, 1000
        ]

    },
]

export const buildingPipe = [
    {
        id: 'bd1',
        location: [110.4518, 36.0662, 1, 110.403928, 36.187045, 1,
            110.444894, 35.648822, 1, 110.122011, 35.246766, 1, 110.060938, 35.238423, 1,
            110.025273, 35.210938, 1, 109.950571, 35.203875, 1, 109.925211, 35.209409, 1,
            109.902462, 35.205339, 1, 109.919885, 35.172704, 1]
        //水库，合阳，澄城县
    },

    {
        id: 'bd2',
        location: [110.122011, 35.246766, 1, 110.11915, 35.106786, 1, 110.132597, 35.083309, 1, 110.173236, 35.082383, 1,
            110.226895, 35.112618, 1, 110.297549, 35.209553, 1,
            110.363543, 35.233096, 1
        ]
        //合阳-入海
    },
    {
        id: 'bd3',
        location: [110.11915, 35.106786, 1, 110.101628, 35.105303, 1, 110.087878, 35.089073, 1, 110.055354, 35.080828, 1,
            110.020999, 35.045836, 1, 109.997783, 35.039091, 1, 109.913387, 35.048505, 1, 109.89002, 35.045417, 1, 109.847761, 35.04927, 1,
            109.811953, 35.06063, 1, 109.620094, 35.057054, 1,
            109.603966, 35.067978, 1,
            109.5876073, 35.1785126, 1
        ]
        //合阳下-白水
    },
    {
        id: 'bd4',
        location: [109.603966, 35.067978, 1, 109.58089, 35.068276, 1, 109.563569, 35.055666, 1, 109.529199, 35.049515, 1,
            109.514429, 35.040331, 1, 109.483902, 35.030013, 1, 109.464987, 35.028261, 1, 109.437589, 35.020095, 1, 109.368467, 34.980628, 1,
            109.323011, 34.967535, 1, 109.240716, 34.89491, 1,
            109.0101221, 34.795362, 1

        ]
        //白水下-三元上
    },
    {
        id: 'bd5',
        location: [110.444894, 35.648822, 1, 110.572163, 35.623351, 1]
    },

    {
        id: '宜川支流',
        location: [110.411557, 36.075064, 1, 110.233311, 36.090088, 1, 110.219282, 36.12213, 1]
    },

    {
        id: '集义支流2',
        location: [110.428612, 35.832793, 1, 110.345197, 35.841018, 1]
    },
    {
        id: '澄城县右支流',
        location: [109.984851, 35.209225, 1, 109.981917, 35.238985, 1, 109.972511, 35.2705, 1,
            109.975579, 35.325332, 1, 109.971955, 35.375431, 1]
        //水库，合阳，澄城县
    },
    {
        id: '澄城县左支流',
        location: [109.902462, 35.205339, 1, 109.903901, 35.21808, 1, 109.905669, 35.241751, 1,
            109.915682, 35.263114, 1, 109.912888, 35.369623, 1]
        //水库，合阳，澄城县
    },
    {
        id: '白水支流',
        location: [109.496233, 35.23634, 1, 109.5876073, 35.1785126, 1, 109.636451, 35.144029, 1, 109.639176, 35.115193, 1]

    },
    {
        id: '白水支流2',
        location: [109.636451, 35.144029, 1, 109.656414, 35.14199, 1, 109.691405, 35.178144, 1]

    },
    {
        id: '佛里下三叉下支流',
        location: [109.812169, 35.060257, 1, 109.772982, 35.018233, 1, 109.753157, 35.014694, 1, 109.702404, 34.964372, 1,
            109.715207, 34.923408, 1, 109.7101, 34.905973, 1, 109.720964, 34.873247, 1]

    },
    {
        id: '下独流',
        location: [109.637331, 34.875446, 1, 109.646551, 34.77905, 1, 109.635532, 34.772648, 1, 109.646918, 34.737379, 1, 109.641845, 34.726991, 1, 109.64784, 34.716666, 1]

    },
    {
        id: '富平上',
        location: [109.053901, 34.816802, 1, 109.097068, 34.7704, 1, 109.1692405, 34.7446812, 1]

    },
    {
        id: '富平园区上',
        location: [109.053901, 34.816802, 1, 109.032604, 34.843788, 1, 109.001289, 34.867637, 1, 108.9378694, 34.6142123, 1]

    },
    {
        id: '龙潭水库',
        location: [109.001289, 34.867637, 1, 108.8558869, 34.9074351, 1]

    },
    {
        id: '东庄水库',
        location: [108.8558869, 34.9074351, 1, 108.4983725, 34.7307591, 1]

    },


]

//110.270545,35.494309,1000
export const highTrunkLine = [
    {
    id: 'ht1',
    categories: 'highTrunkLine',
    location: [110.4518,36.0662,1000,110.421866,36.014382,1000,
        110.369353,36.072997,1000,110.456299,35.692667,1000,
        110.270545,35.494309,1000,110.101323,35.246552,1000,
        110.087364,35.137277,1000,109.921968,35.081337,1000,
        109.684586,35.068852,1000,109.425277,35.03334,1000,
        109.24191999999994,34.920866000000004,1000,108.94388700000002,34.762381, 1000
    ]
},
    {
        id: 'ht2',
        categories: 'highTrunkLine',
        location: [110.087364,35.137277,1000, 110.097639,34.976444,1000
        ]
    },
    {
        id: 'ht3',
        categories: 'highTrunkLine',
        location: [110.101323,35.246552,1000, 110.045282,35.338989,1000,
            109.870054,35.360938,1000,109.737464,35.377572,1000,
            109.632367,35.415022,1000
        ]
    }

]

export const channel = [
    {
        id: 'ch1',
        categories: 'channel',
        location: [110.36751,35.224677,1000,110.249318,34.977308,1000,
            110.097639,34.976444,1000,109.907903,34.917166,1000,
            109.812922,34.900315,1000,109.677815,34.917281,1000,
            109.518483,34.902262,1000,109.324619,34.828442,1000
        ]
    },
]


export const BranchTrunkLine = [
    {
        id: 'btl1',
        categories: 'branchTrunkLine',
        location: [110.369353,36.072997,1000,110.24850900000001,36.06567499999999, 1000
        ]
    },
    {
        id: 'btl2',
        categories: 'branchTrunkLine',
        location: [110.19613,35.386905,1000,110.240804,35.36789, 1000,
            110.232827,35.345336,1000,110.257787,35.326303,1000,
            110.294291,35.31771,1000,110.332255,35.316364,1000
        ]
    },    {
        id: 'btl3',
        categories: 'branchTrunkLine',
        location: [
            110.048756,35.341502,1000,110.087956,35.355129,1000,
            110.080109,35.380138,1000,110.088622,35.408808,1000
        ]
    },  {
        id: 'btl4',
        categories: 'branchTrunkLine',
        location: [
            110.007065,35.346975,1000,110.02131,35.399806,1000,
            110.047226,35.463474,1000,

        ]
    },
    {
        id: 'btl6',
        categories: 'branchTrunkLine',
        location: [
            110.007065,35.346975,1000,110.008831,35.299413,1000

        ]
    },
    {
        id: 'btl7',
        categories: 'branchTrunkLine',
        location: [
            109.958084,35.357344,1000,109.960138,35.401961,1000,
            109.950223,35.42966,1000,109.935464,35.456338,1000

        ]
    },    {
        id: 'btl8',
        categories: 'branchTrunkLine',
        location: [
            109.837979,35.366895,1000, 109.842128,35.412812,1000,
            109.862548,35.455405,1000

        ]
    },   {
        id: 'btl9',
        categories: 'branchTrunkLine',
        location: [
            109.778139,35.375935,1000, 109.812428,35.403192,1000,
            109.811995,35.452373,1000

        ]
    },  {
        id: 'btl10',
        categories: 'branchTrunkLine',
        location: [
            110.096155,34.974438,1000,110.045947,34.879309,1000,
            110.028078,34.854806,1000,109.998576,34.84651,1000,
            109.999007,34.797671,1000,110.033747,34.767996,1000,
            110.019136,34.748913,1000,110.031235,34.678345,1000
        ]
    },
    {
        id: 'btl11',
        categories: 'branchTrunkLine',
        location: [
            109.75058,34.902461,1000,109.698512,34.846479,1000,
            109.671924,34.79068,1000,109.624925,34.770695,1000,
            109.661773,34.728988,1000,109.669705,34.673442,1000,
            109.564717,34.648302,1000
        ]
    },
    {
        id: 'btl12',
        categories: 'branchTrunkLine',
        location: [
            109.424472,34.867137,1000,109.437566,34.776553,1000,
            109.447146,34.731249,1000,109.475303,34.650723,1000

        ]
    },
    {
        id: 'btl13',
        categories: 'branchTrunkLine',
        location: [
            109.757224,35.073842,1000,109.747361,35.00598,1000,
            109.749838,34.969475,1000,109.754561,34.91905,1000

        ]
    },
    {
        id: 'btl14',
        categories: 'branchTrunkLine',
        location: [
            109.492193,35.051375,1000,109.508341,34.977401,1000,
            109.526929,34.913986,1000

        ]
    },
    {
        id: 'btl15',
        categories: 'branchTrunkLine',
        location: [
            109.356092,34.994949,1000,109.466777,34.900154,1000

        ]
    },
    {
        id: 'btl16',
        categories: 'branchTrunkLine',
        location: [
            109.623618,35.068803,1000,109.574162,35.116585,1000,
            109.534623,35.150368,1000,109.482341,35.21815,1000
        ]
    },
]
